import {generateRandomString} from '@/utils/uuid'
import { getUserInfoByToken } from '@/api/user'

const state = {
    token: localStorage.getItem('token') || '',
    session_id: localStorage.getItem('session_id') || '',
    permissions: [],
    userInfo: null,
    systemType: localStorage.getItem('systemType') || '',
    ssoToken: localStorage.getItem('ssoToken') || ''
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    CLEAR_TOKEN: (state) => {
        state.token = ''
    },
    SET_SESSION_ID: (state, id) => {
        state.session_id = id
        localStorage.setItem('session_id', id)
    },
    CLEAR_SESSION_ID: (state) => {
        state.session_id = ''
        localStorage.removeItem('session_id')
    },
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
    },
    CLEAR_PERMISSIONS: (state) => {
        state.permissions = []
    },
    SET_USER_INFO: (state, userInfo) => {
        state.userInfo = userInfo
    },
    CLEAR_USER_INFO: (state) => {
        state.userInfo = null
    },
    SET_SYSTEM_TYPE: (state, type) => {
        state.systemType = type
    },
    CLEAR_SYSTEM_TYPE: (state) => {
        state.systemType = ''
    },
    SET_SSO_TOKEN: (state, token) => {
        state.ssoToken = token
    },
    CLEAR_SSO_TOKEN: (state) => {
        state.ssoToken = ''
    }
}

const actions = {
    // 设置token
    setToken({commit}, token) {
        localStorage.setItem('token', token)
        commit('SET_TOKEN', token)
    },

    // 清空token
    clearToken({commit}) {
        localStorage.removeItem('token')
        commit('CLEAR_TOKEN')
    },

    // 设置sso token
    setSsoToken({ commit }, token) {
        localStorage.setItem('ssoToken', token)
        commit('SET_SSO_TOKEN', token)
    },

    // 清空sso token
    clearSsoToken({ commit }) {
        localStorage.removeItem('ssoToken')
        commit('CLEAR_SSO_TOKEN')
    },

    // 设置系统类型
    setSystemType({ commit }, type) {
        localStorage.setItem('systemType', type)
        commit('SET_SYSTEM_TYPE', type)
    },

    // 清空系统类型
    clearSystemType({ commit }) {
        localStorage.removeItem('systemType')
        commit('CLEAR_SYSTEM_TYPE')
    },


    // 登出操作
    logout({dispatch}) {
        return new Promise((resolve) => {
            dispatch('clearToken')
            dispatch('clearUserInfo')
            dispatch('clearSsoToken')
            dispatch('clearSystemType')
            // 可以在这里添加其他登出逻辑，如清除用户信息等
            resolve()
        })
    },

    /**
     * 生成新的会话ID
     */
    generateSessionId({commit}, val = '') {
        const sessionId = val ? val : generateRandomString(16)
        commit('SET_SESSION_ID', sessionId)
        return sessionId
    },

    /**
     * 清除会话ID
     */
    clearSessionId({commit}) {
        commit('CLEAR_SESSION_ID')
    },

    /**
     * 设置用户菜单权限
     */
    setUserInfo({ commit }) {
        return getUserInfoByToken().then(res => {
            commit('SET_PERMISSIONS', res.data.permissions)
            commit('SET_USER_INFO', res.data)
            return res.data
        })
    },

    /**
     * 清除用户菜单权限
     */
    clearUserInfo({commit}) {
        commit('CLEAR_PERMISSIONS')
        commit('CLEAR_USER_INFO')
    }
}

const getters = {
    token: state => state.token,
    isAuthenticated: state => !!state.token,
    userInfo: state => state.userInfo,
    permissions: state => state.permissions,
    systemType: state => state.systemType,
    ssoToken: state => state.ssoToken
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
